import {
  Heading,
  Flex,
  Text,
  AspectRatio,
  Image,
  Grid,
} from "@chakra-ui/react";
import React from "react";
import PageWrapper from "../Common/PageWrapper";
const pic1 = require("../../assets/1.jpg");

type InfoPageProps = {};

const InfoPage: React.FC<InfoPageProps> = () => {
  return (
    <PageWrapper>
      <Heading mb={12}>
        Tervetuloa Kauhavan veteraanitalon kotisivuille!
      </Heading>
      <Grid
        maxW="1200px"
        gap={8}
        gridTemplateColumns={{ base: "1fr", lg: "1fr 1fr" }}
      >
        <Flex direction="column" textAlign="justify">
          <Text mb={2}>
            Talon omistaa Kauhava-seura ry. Talo sijaitsee Kosolanmäellä
            osoitteessa Museotie 16 62200 Kauhava Talon historiasta voi lukea
            näiden kotisivujen Historia-osiosta. Talossa on paljon veteraanien
            tekemiä esineitä sekä kuvia.
          </Text>

          <Heading fontSize="xl" mt={4} mb={2}>
            Tietoa talosta
          </Heading>
          <Text mb={2}>
            Talo on kooltaan n. 7 x 9 metriä. Talossa on tuulikaappi, eteinen,
            keittiö, suurehko kulmikas huone ja WC. Keittiössä on sähköhella,
            kahvinkeitin, jääkaappi, kahviastiasto ja pieni pöytä. Isommissa
            huoneissa on pöytätilaa n. 10 hengelle ja erillisiä istuimia on n.
            40 hengelle.
          </Text>
          <Text mb={2}>
            Lisäpöydille on tarvittaessa tilaa. Lämmityksenä on suora sähkö sekä
            ilmalämpöpumppu. Taloa voi siis hyvin käyttää myös talviaikaan.
            Pihassa on omaa parkkitilaa noin 20 autolle.
          </Text>
          <Heading fontSize="xl" mt={4} mb={2}>
            Talon käyttö
          </Heading>
          <Text mb={2}>
            Talossa voi pitää kokouksia ja pieniä perhejuhlia. Kokouksia varten
            on käytössä iso taulu-TV. Talon käytöstä vastaa{" "}
            <b>Seppo Ruotsala puh 040-1395004. </b>
            Sähköposti: seppo.ruotsala@gmail.com
          </Text>
          <Text mb={6}>Käyttömaksu: Kokous 25 €, koko päivä 60 €</Text>
          <Text mb={2}>Varaustilanteen näet kalenteri-sivulta.</Text>
        </Flex>

        <AspectRatio h="min-content" ratio={4 / 3} mt={2}>
          <Image src={pic1} alt="veteraanitalo" objectFit="cover" />
        </AspectRatio>
      </Grid>
    </PageWrapper>
  );
};
export default InfoPage;
